import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../../constants';
import type { TAPIFetchTechDetails } from './fetch-technical-details.hook.types';
import type { TTechDetailsResponse } from '../technical-details.types';

export const useAPIFetchTechDetails = (): TAPIFetchTechDetails => {
  const { get, error, loading, response, data } = useFetch<TTechDetailsResponse>(API_ROUTES.APPLICATIONS, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  async function fetchTechDetails(applicationId: string): Promise<TTechDetailsResponse['data']> {
    const data = await get(`${applicationId}/tech-details`);

    return data?.data;
  }

  return {
    data: data?.data,
    loading,
    error,
    loaded: response.ok,
    fetchTechDetails,
  };
};
